// src/components/CountdownWatcher.jsx
import { useEffect } from "react";
import { supabase } from "../utils/supabaseClient";

export default function CountdownWatcher({ toast }) {
  useEffect(() => {
    const checkCountdown = async () => {
      const { data, error } = await supabase
        .from("dispatch_queue")
        .select("postcode_sector, ready_at")
        .lt("saturation", 1.0)
        .gt("ready_at", new Date(Date.now() - 28 * 24 * 60 * 60 * 1000).toISOString());

      if (error) {
        console.error("Countdown error:", error);
        return;
      }

      data?.forEach(({ postcode_sector, ready_at }) => {
        const daysElapsed = Math.floor((Date.now() - new Date(ready_at)) / (1000 * 60 * 60 * 24));
        const daysRemaining = 28 - daysElapsed;

        if (daysRemaining <= 7) {
          toast({
            title: "Auto-Fill Approaching",
            description: `⏳ ${postcode_sector} will auto-fill in ${daysRemaining} days.`,
            status: "warning",
            duration: 5000,
            isClosable: true,
          });
        }
      });
    };
    checkCountdown();
  }, [toast]);

  return null;
}
